<template>
    <div v-if="signalRSocket">
        <div class="tabs is-centered is-toggle is-medium mt-3">
            <ul>
                <li :class="{ 'is-active': active === 'panel' }">
                    <a @click="active = 'panel'">
                        <span>OPERADORES</span>
                    </a>
                </li>
                <li :class="{ 'is-active': active === 'dashboard' }">
                    <a @click="active = 'dashboard'">
                        <span>DASHBOARD</span>
                    </a>
                </li>
                <li :class="{ 'is-active': active === 'report' }">
                    <a @click="active = 'report'">
                        <span>REPORTES</span>
                    </a>
                </li>
            </ul>
        </div>
        <div v-show="active === 'panel'">
            <OnlineOperators :signalRSocket="signalRSocket" :skills="skills" />
            <OnlineRoomsList :signalRSocket="signalRSocket" :skills="skills" />
        </div>
        <div v-show="active === 'dashboard'">
            <SupervisorDashboard :signalRSocket="signalRSocket" />
        </div>
        <div v-show="active === 'report'">
            <SupervisorReport :signalRSocket="signalRSocket" />
        </div>
    </div>
</template>

<script>
import * as SignalR from "@microsoft/signalr";
import { RepositoryFactory } from "@/services/api";

import OnlineOperators from "@/components/online-operators-list/OnlineOperators.vue";
import OnlineRoomsList from "@/components/online-rooms-list/OnlineRoomsList.vue";
import SupervisorDashboard from "@/components/supervisor/SupervisorDashboard.vue";
import SupervisorReport from "@/components/supervisor/SupervisorReport.vue";

export default {
    name: "supervisor-panel",
    components: {
        OnlineOperators,
        OnlineRoomsList,
        SupervisorDashboard,
        SupervisorReport,
    },
    data() {
        return {
            signalRSocket: null,
            active: "panel",
            skills: [],
        };
    },
    async mounted() {
        await this.signalRInitialize();
    },
    async beforeDestroy() {
        let socket = this.signalRSocket;
        this.signalRSocket = null;
        await socket.stop();
    },
    created() {
        this.retrieveSkills();
    },
    methods: {
        async signalRInitialize() {
            try {
                const socket = new SignalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_ONLINE_HUB)
                    .withAutomaticReconnect()
                    .build();

                socket.connection.onclose = async (error) => {
                    if (error !== undefined) {
                        this.$log(error);
                    }

                    if (this.signalRSocket !== null) {
                        this.$log("Reconnecting...");
                        this.signalRSocket = false;
                        await this.signalRInitialize();
                    }
                };

                await socket.start();

                this.signalRSocket = socket;
            } catch (err) {
                this.$log("Error, reconnecting...");

                setTimeout(() => {
                    this.signalRInitialize();
                }, 1000);
            }
        },
        async retrieveSkills() {
            try {
                let response = await RepositoryFactory.operators.getSkills();
                this.skills = response.data;
            } catch (error) {
                window.console.log(error);
            }
        },
    },
};
</script>